import React from "react";
import { Dialog, DialogContent, DialogTitle, DialogActions } from "@material-ui/core";

import Button from "../../../../../../components/common/PL/Button/Button";
import { AuthorizationPerson, ManagerStatus } from "./transportAuthorizationTypes";

import "./AutorizadoresModal.css";

export const MANAGER_STATUS_LABELS: Record<ManagerStatus, string> = {
  pending: "pendiente",
  approved: "aprobó",
  rejected: "rechazó",
};

type AutorizadoresModalProps = {
  open: boolean;
  onClose: () => void;
  people: AuthorizationPerson[];
};

const AutorizadoresModal: React.FC<AutorizadoresModalProps> = ({ open, onClose, people }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        className: "autorizadoresModalCard",
        onClick: (e: React.MouseEvent) => e.stopPropagation(),
      }}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle disableTypography className="autorizadoresModalTitle">
        Autorizadores notificados
      </DialogTitle>
      <DialogContent className="autorizadoresModalContent">
        {people.length === 0 ? (
          <span className="autorizadoresModalEmpty">No hay autorizadores notificados.</span>
        ) : (
          people.map((person) => (
            <div key={person.user} className="autorizadoresModalRow">
              <div className="autorizadoresModalRowInfo">
                <span className="autorizadoresModalRowName">{person.name}</span>
                <span className="autorizadoresModalRowPhone">Tel: {person.phone}</span>
              </div>
              <span className="autorizadoresModalRowStatus">
                {MANAGER_STATUS_LABELS[person.status]}
              </span>
            </div>
          ))
        )}
      </DialogContent>
      <DialogActions className="autorizadoresModalActions">
        <Button variant="outline" onClick={onClose} className="autorizadoresModalButton">
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AutorizadoresModal;
